import { all } from 'redux-saga/effects';
import {
  watchClientUserAgreementGet,
  watchSetUserAgreementAcceptance,
  watchGetUserAgreementAcceptance,
} from './agreementsSaga';

// Shape of the saga config object threaded through the watcher sagas.
interface AgreementsSagaConfig {
  baseApiUrl: string;
  getAuthToken: (key?: string) => string;
}

// export wrapper function to capture client config for sagas to read from
export default (config: AgreementsSagaConfig = {} as AgreementsSagaConfig) =>
  // return our rootSaga
  function* rootSaga(): Generator<unknown, void, unknown> {
    yield all([
      // import all additional watcher sagas here
      watchClientUserAgreementGet(config),
      watchSetUserAgreementAcceptance(config),
      watchGetUserAgreementAcceptance(config),
    ]);
  };
